import { render, staticRenderFns } from "./ViewProjectsSubmitted.vue?vue&type=template&id=7966ba04&scoped=true"
import script from "./ViewProjectsSubmitted.vue?vue&type=script&lang=ts"
export * from "./ViewProjectsSubmitted.vue?vue&type=script&lang=ts"
import style0 from "./ViewProjectsSubmitted.vue?vue&type=style&index=0&id=7966ba04&prod&lang=css"
import style1 from "./ViewProjectsSubmitted.vue?vue&type=style&index=1&id=7966ba04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7966ba04",
  null
  
)

export default component.exports